import type { Maybe } from "@entrilia/shared/types.ts";
import type {
  ConditionField,
  GroupingField,
  ReportField,
  SortConfiguration,
  TabularConfiguration,
  TabularGeneralSettings,
} from "../../../../../../../../api/types/svTypes.ts";
import { ReportType } from "../../../../../../../../api/types/svTypes.ts";
import { getCashFlowSettings } from "../../cash-flow/getCashFlowSettings.ts";

export const createTabularDataRequest = (
  allConditions: ConditionField[],
  fields: ReportField[],
  sorting: SortConfiguration[],
  grouping: GroupingField[],
  settings: TabularGeneralSettings,
  reportType: Maybe<ReportType>
): TabularConfiguration => {
  const result: TabularConfiguration = {
    conditions: allConditions.map((c) => ({ ...c.config, invalid: c.validation?.invalid })),
    fields: fields.map((f) => f.config),
    sort: sorting,
    grouping: grouping.map((g) => ({ ...g, hideSummaries: g.hideSummaries ?? false })),
    settings: reportType === ReportType.CashFlow ? { ...settings, cashFlow: getCashFlowSettings(settings) } : settings,
  };

  return result;
};
